import { Snackbar, Alert } from '@mui/material';


export function AlertBar({ open, handleClose, message, severity = 'info' }) {
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        handleClose(event, reason);
    };

    const handleAlertClose = (event) => {
        handleClose(event);
    };
    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert onClose={handleAlertClose} severity={severity} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
}